import { render, staticRenderFns } from "./Bpjs.vue?vue&type=template&id=26254840"
import script from "./Bpjs.vue?vue&type=script&lang=js"
export * from "./Bpjs.vue?vue&type=script&lang=js"
import style0 from "./Bpjs.vue?vue&type=style&index=0&id=26254840&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports